<script lang="ts">
  import { onMount } from "svelte";
  import { Router, Route } from "svelte-routing";
  import Page from "./lib/Page.svelte";
  import NotFound from "./lib/NotFound.svelte";
  import KontaktPage from "./lib/KontaktPage.svelte";
  import ShopPage from "./lib/ShopPage.svelte";
  import DemoPage from "./lib/DemoPage.svelte";
  import BetaPage from "./lib/BetaPage.svelte";
  import BetaBanner from "./lib/BetaBanner.svelte";
  import Redirect from "./lib/Redirect.svelte";
  import { pages } from "./lib/pages";
  import { initBeta } from "./lib/beta";

  export let url = "";

  // Load the runtime beta flag once on startup; fail-soft (leaves it off).
  onMount(() => {
    void initBeta();
  });

  // Route IDs that get an interactive Svelte override instead of the static
  // {@html} partial (live forms / demo actions wired to the backend). The
  // generated partials for these ids are intentionally NOT rendered via <Page>.
  const OVERRIDES = new Set(["kontakt", "shop", "demo", "jetzt-starten-demo"]);
  $: staticPages = pages.filter((p) => !OVERRIDES.has(p.id));
</script>

<Router {url}>
  <!-- Must live INSIDE <Router>: BetaBanner renders a svelte-routing <Link>,
       which needs the Router context. Outside the Router the <Link> throws on
       missing context, which breaks Svelte's scheduler and freezes SPA nav. -->
  <BetaBanner />
  {#each staticPages as page (page.id)}
    <Route path={page.path}>
      <Page id={page.id} />
    </Route>
  {/each}
  <Route path="/kontakt"><KontaktPage /></Route>
  <Route path="/shop"><ShopPage /></Route>
  <Route path="/demo"><DemoPage id="demo" /></Route>
  <Route path="/jetzt-starten-demo"><DemoPage id="jetzt-starten-demo" /></Route>
  <Route path="/beta"><BetaPage /></Route>
  <Route path="/gehostet"><Redirect to="/jetzt-starten" /></Route>
  <Route path="/gehostet-demo"><Redirect to="/jetzt-starten-demo" /></Route>
  <Route path="*"><NotFound /></Route>
</Router>
